import React, { useCallback, useMemo } from 'react';

import { jsonStringify } from '@lyearn/core/utils/json';
import { useTranslation } from '@lyearn/i18n';
import {
  ExternalEventProviderInfoInput,
  FormComponentFieldTypeEnum,
  FormComponentType,
} from '@/types/schema';

import { getProviderMetaObj } from '../../../utils';
import MetaField from '../MetaField';
import { isExternalProviderUrlValid } from '../utils';

interface ProviderFormInputProps {
  formInputs: FormComponentType[];
  value: ExternalEventProviderInfoInput;
  onChange: (value: ExternalEventProviderInfoInput) => void;
  disabled?: boolean;
}

function ProviderFormInputs(props: ProviderFormInputProps) {
  const { t } = useTranslation();
  const { formInputs, value, onChange, disabled } = props;

  const metaObj = useMemo(() => getProviderMetaObj(value), [value]);
  const onMetaChange = useCallback(
    (fieldName: string, nextValue: string) =>
      onChange({ ...value, meta: jsonStringify({ ...metaObj, [fieldName]: nextValue }).data! }),
    [metaObj, onChange, value],
  );

  const isProviderUrlEmpty = isExternalProviderUrlValid(value);

  return (
    <>
      {formInputs?.map((formInput) => (
        <MetaField
          key={formInput.name}
          className="meta-field flex-1 space-y-8"
          disabled={disabled}
          error={
            formInput.type === FormComponentFieldTypeEnum.Url && isProviderUrlEmpty
              ? t('Events:Editor.InvalidLink')
              : undefined
          }
          field={formInput}
          value={metaObj[formInput.name]}
          onChange={onMetaChange}
        />
      ))}
    </>
  );
}

export default ProviderFormInputs;
